<template>
<div class="chapter">
<div class="inner_page">
<h2 class="chapter" id="heading_id_2">4</h2>
<p class="right1">Present Day<br/>
  July 26<br/>
  11:01 PM</p>
<p class="right1"><em>The Marina District<br/>
  San Francisco, California</em></p>
<p class="section">San Francisco Police Inspector Lance Burden greeted the first officer on-scene with a firm nod. “What’s the deal?”</p>
<p>The man tipped back his cap and shifted his weight. “Pretty disgusting, if you ask me, Inspector.”</p>
<p>Burden yawned wide and hard, then said, “I did ask you. Can you be a little more specific?”</p>
<p>“Victim is an old woman. I didn’t want to mess up the crime scene and shit, so I’m just eyeballing it, but she looks like she’s in her eighties.”</p>
<p>“Okay. Go on.”</p>
<p>“Kind of looks like my grandmother.”</p>
<p>“She’s old. I got that. What else?”</p>
<p>“Her pants and underwear are pulled down to her knees. She’s...uh...she’s been penetrated.”</p>
<p>“Penetrated—how? You mean sexually?”</p>
<p>The officer rested both hands on his utility belt and hooked fingers around the gear. “Yeah. There’s something rammed up her, up her anus.” He looked away, shook his head, then continued. “Like I said. Disgusting. I mean, who’d want to rape and sodomize an old woman?”</p>
<p>Burden’s eyes widened. “Wait here.”</p>
<p>“Don’t worry. I’m not goin’ back in there,” the cop said with a sardonic chuckle.</p>
<p>Burden lifted his two-way and got an ETA on the criminalist: fifteen minutes, best case. His partner was en route, as well, but he decided not to wait. He pulled a pair of blue booties from his pocket—he’d learned first day on the job as a detective years ago to carry the things with him. And they’d come in handy on more than one occasion.</p>
<p>He walked into the townhouse. A sour-stale odor flared his nostrils. It was a scent he’d experienced a number of times over the years—the way homes of elderly individuals can sometimes smell, particularly when mixed with the putrid cologne of death.</p>
<p>The place was well kept, orderly, and clean. Oil paintings and dated knickknacks betrayed their age about as blatantly as the yellowing black-and-white photographs that sat on a bureau in the living room.</p>
<p>And then, in the bedroom...two bare feet visible from the doorway. Burden walked another couple of yards and had enough of a view to get a sense of what he was dealing with. He bit the inside of his lip.</p>
<p>“Inspector.”</p>
<p>Burden did not look away from the body. “What is it?”</p>
<p>“The criminalist made better time than he thought. He’ll be here in five minutes.”</p>
<p>“Yeah. Right. Send him in when he gets here.”</p>
<p>“See what I mean?” the officer asked. “What kind of monster would do that to a poor old woman?”</p>
<p>Burden sighed deeply. “I think I know just the kind of monster we’re looking for. And I know who to call to help find him.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?1651e162